'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFilm = function FaFilm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8 34.6v-2.6q0-0.6-0.4-1t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 1v2.6q0 0.6 0.4 1t0.9 0.3h2.6q0.6 0 1-0.3t0.4-1z m0-8v-2.6q0-0.6-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.6q0 0.6 0.4 1t0.9 0.4h2.6q0.6 0 1-0.4t0.4-1z m0-7.9v-2.7q0-0.5-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.6q0.6 0 1-0.4t0.4-0.9z m21.2 15.9v-10.6q0-0.6-0.4-0.9t-0.9-0.4h-15.9q-0.6 0-1 0.4t-0.4 0.9v10.6q0 0.6 0.4 1t1 0.3h15.9q0.5 0 0.9-0.3t0.4-1z m-21.2-23.9v-2.7q0-0.5-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.6q0.6 0 1-0.4t0.4-0.9z m29.2 23.9v-2.6q0-0.6-0.4-1t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 1v2.6q0 0.6 0.4 1t0.9 0.3h2.7q0.5 0 0.9-0.3t0.4-1z m-8-15.9v-10.7q0-0.5-0.4-0.9t-0.9-0.4h-15.9q-0.6 0-1 0.4t-0.4 0.9v10.7q0 0.5 0.4 0.9t1 0.4h15.9q0.5 0 0.9-0.4t0.4-0.9z m8 7.9v-2.6q0-0.6-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.6q0 0.6 0.4 1t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-1z m0-7.9v-2.7q0-0.5-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-0.9z m0-8v-2.7q0-0.5-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-0.9z m2.7-3.3v27.9q0 1.4-1 2.3t-2.4 1h-33.2q-1.3 0-2.3-1t-1-2.3v-27.9q0-1.4 1-2.4t2.3-0.9h33.2q1.4 0 2.4 0.9t1 2.4z' })
        )
    );
};

exports.default = FaFilm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/film.js
// module id = 1232
// module chunks = 0